export default __webpack_public_path__ + "static/media/YOOZ_ONLINE.b5a58f04.png";